export type ProjectStatus =
  | "scheduled"
  | "in-progress"
  | "completed"
  | "on-hold"
  | "cancelled";

export type ProjectListItem = {
  id: string;
  customer: string;
  customerInitials: string;
  customerColor: string;
  moveType: string;
  date: string;
  time: string;
  fromCity: string;
  toCity: string;
  truck: string;
  crewCount: number;
  leadCrew: string;
  status: ProjectStatus;
  total: number;
  depositPaid: boolean;
};

export const projectsList: ProjectListItem[] = [
  {
    id: "MV-2041",
    customer: "Margaret Sullivan",
    customerInitials: "MS",
    customerColor: "bg-brand-500",
    moveType: "Residential — 3 BR House",
    date: "Jun 01, 2026",
    time: "07:30",
    fromCity: "Austin, TX",
    toCity: "Round Rock, TX",
    truck: "26ft Box Truck",
    crewCount: 3,
    leadCrew: "Marcus Reed",
    status: "in-progress",
    total: 2480,
    depositPaid: true,
  },
  {
    id: "MV-2042",
    customer: "Jonathan Park",
    customerInitials: "JP",
    customerColor: "bg-indigo-500",
    moveType: "Office Relocation",
    date: "Jun 01, 2026",
    time: "09:00",
    fromCity: "Austin, TX",
    toCity: "Austin, TX",
    truck: "26ft Box Truck",
    crewCount: 4,
    leadCrew: "Samira Khan",
    status: "in-progress",
    total: 4880,
    depositPaid: true,
  },
  {
    id: "MV-2043",
    customer: "Priya Iyer",
    customerInitials: "PI",
    customerColor: "bg-pink-500",
    moveType: "Apartment — Studio",
    date: "Jun 01, 2026",
    time: "11:30",
    fromCity: "Austin, TX",
    toCity: "Austin, TX",
    truck: "16ft Cargo Van",
    crewCount: 2,
    leadCrew: "Wes Holloway",
    status: "scheduled",
    total: 720,
    depositPaid: true,
  },
  {
    id: "MV-2044",
    customer: "Travis & Hannah Bell",
    customerInitials: "TB",
    customerColor: "bg-emerald-600",
    moveType: "Residential — 2 BR Townhouse",
    date: "Jun 01, 2026",
    time: "13:00",
    fromCity: "Cedar Park, TX",
    toCity: "Leander, TX",
    truck: "20ft Box Truck",
    crewCount: 3,
    leadCrew: "Owen Patel",
    status: "scheduled",
    total: 1640,
    depositPaid: true,
  },
  {
    id: "MV-2045",
    customer: "Eleanor Whitfield",
    customerInitials: "EW",
    customerColor: "bg-fuchsia-500",
    moveType: "Long Distance — 4 BR House",
    date: "Jun 01, 2026",
    time: "15:30",
    fromCity: "Georgetown, TX",
    toCity: "San Antonio, TX",
    truck: "26ft + Trailer",
    crewCount: 4,
    leadCrew: "Kenji Yamada",
    status: "scheduled",
    total: 6240,
    depositPaid: false,
  },
  {
    id: "MV-2046",
    customer: "Carla Mendez",
    customerInitials: "CM",
    customerColor: "bg-amber-600",
    moveType: "Apartment — 2 BR",
    date: "Jun 02, 2026",
    time: "08:00",
    fromCity: "Austin, TX",
    toCity: "Pflugerville, TX",
    truck: "20ft Box Truck",
    crewCount: 3,
    leadCrew: "Diego Alvarez",
    status: "scheduled",
    total: 1240,
    depositPaid: true,
  },
  {
    id: "MV-2047",
    customer: "Hiroshi Tanaka",
    customerInitials: "HT",
    customerColor: "bg-rose-500",
    moveType: "Residential — 1 BR Condo",
    date: "Jun 02, 2026",
    time: "10:00",
    fromCity: "Austin, TX",
    toCity: "Austin, TX",
    truck: "16ft Cargo Van",
    crewCount: 2,
    leadCrew: "Nina Castro",
    status: "scheduled",
    total: 580,
    depositPaid: true,
  },
  {
    id: "MV-2048",
    customer: "Genesis Holdings LLC",
    customerInitials: "GH",
    customerColor: "bg-teal-600",
    moveType: "Commercial — Warehouse",
    date: "Jun 03, 2026",
    time: "06:00",
    fromCity: "Austin, TX",
    toCity: "San Marcos, TX",
    truck: "26ft + 16ft",
    crewCount: 5,
    leadCrew: "Aaron Mills",
    status: "scheduled",
    total: 7850,
    depositPaid: true,
  },
  {
    id: "MV-2049",
    customer: "Rebecca Lin",
    customerInitials: "RL",
    customerColor: "bg-cyan-600",
    moveType: "Apartment — Studio",
    date: "Jun 03, 2026",
    time: "13:30",
    fromCity: "Austin, TX",
    toCity: "Austin, TX",
    truck: "16ft Cargo Van",
    crewCount: 2,
    leadCrew: "Tyler Brooks",
    status: "on-hold",
    total: 540,
    depositPaid: false,
  },
  {
    id: "MV-2050",
    customer: "Devon & Lily Hartwell",
    customerInitials: "DH",
    customerColor: "bg-orange-600",
    moveType: "Residential — 4 BR House",
    date: "Jun 04, 2026",
    time: "07:00",
    fromCity: "Round Rock, TX",
    toCity: "Austin, TX",
    truck: "26ft Box Truck",
    crewCount: 4,
    leadCrew: "Ronnie Vega",
    status: "scheduled",
    total: 3120,
    depositPaid: true,
  },
  {
    id: "MV-2039",
    customer: "Joaquin Rivera",
    customerInitials: "JR",
    customerColor: "bg-emerald-500",
    moveType: "Apartment — 2 BR",
    date: "May 31, 2026",
    time: "09:00",
    fromCity: "Austin, TX",
    toCity: "Austin, TX",
    truck: "20ft Box Truck",
    crewCount: 3,
    leadCrew: "Marcus Reed",
    status: "completed",
    total: 1380,
    depositPaid: true,
  },
  {
    id: "MV-2038",
    customer: "Anika Brennan",
    customerInitials: "AB",
    customerColor: "bg-violet-500",
    moveType: "Residential — 3 BR House",
    date: "May 30, 2026",
    time: "08:30",
    fromCity: "Cedar Park, TX",
    toCity: "Austin, TX",
    truck: "26ft Box Truck",
    crewCount: 3,
    leadCrew: "Samira Khan",
    status: "completed",
    total: 2240,
    depositPaid: true,
  },
  {
    id: "MV-2037",
    customer: "Marcus Tribble",
    customerInitials: "MT",
    customerColor: "bg-lime-600",
    moveType: "Apartment — 1 BR",
    date: "May 29, 2026",
    time: "11:00",
    fromCity: "Austin, TX",
    toCity: "Buda, TX",
    truck: "16ft Cargo Van",
    crewCount: 2,
    leadCrew: "Wes Holloway",
    status: "cancelled",
    total: 0,
    depositPaid: false,
  },
];

export type ProjectDetail = {
  id: string;
  status: ProjectStatus;
  moveType: string;
  scheduledStart: string;
  scheduledEnd: string;
  estimatedHours: number;
  distanceMiles: number;
  notes: string;
  createdAt: string;

  customer: {
    name: string;
    initials: string;
    avatarColor: string;
    email: string;
    phone: string;
    altPhone: string;
    referredBy: string;
    customerSince: string;
    completedMoves: number;
  };

  fromAddress: {
    label: string;
    line1: string;
    line2: string;
    city: string;
    state: string;
    zip: string;
    accessNotes: string;
  };

  toAddress: {
    label: string;
    line1: string;
    line2: string;
    city: string;
    state: string;
    zip: string;
    accessNotes: string;
  };

  truck: {
    size: string;
    plate: string;
    capacityCuFt: number;
    needed: number;
  };

  crew: {
    id: string;
    name: string;
    role: string;
    phone: string;
    initials: string;
    color: string;
    status: "confirmed" | "tentative";
    rating: number;
  }[];

  items: {
    id: string;
    name: string;
    qty: number;
    category: string;
    fragile?: boolean;
    cuft?: number;
  }[];

  checklist: {
    id: string;
    label: string;
    category: string;
    done: boolean;
    assignee?: string;
  }[];

  pricing: {
    subtotal: number;
    deposit: number;
    depositPaid: boolean;
    fuelSurcharge: number;
    materials: number;
    tax: number;
    total: number;
    balanceDue: number;
  };

  timeline: {
    id: string;
    time: string;
    title: string;
    detail: string;
    icon: string;
    iconColor: string;
    iconBg: string;
  }[];
};

export const projectDetails: Record<string, ProjectDetail> = {
  "MV-2041": {
    id: "MV-2041",
    status: "in-progress",
    moveType: "Residential — 3 BR House",
    scheduledStart: "Mon Jun 01, 07:30 AM",
    scheduledEnd: "Mon Jun 01, 01:30 PM",
    estimatedHours: 6,
    distanceMiles: 22,
    notes:
      "Customer has a piano on the 2nd floor — needs piano dolly and 4-person carry. Driveway is narrow, park truck on street and use shuttle dolly. No elevator at origin.",
    createdAt: "May 14, 2026",
    customer: {
      name: "Margaret Sullivan",
      initials: "MS",
      avatarColor: "bg-brand-500",
      email: "margaret.sullivan@gmail.com",
      phone: "(512) 555-0142",
      altPhone: "(512) 555-0177",
      referredBy: "Yelp listing",
      customerSince: "Mar 2024",
      completedMoves: 2,
    },
    fromAddress: {
      label: "Origin",
      line1: "412 Maple Ridge Dr",
      line2: "",
      city: "Austin",
      state: "TX",
      zip: "78745",
      accessNotes: "Narrow driveway, park on street. No elevator. 2 flights of stairs.",
    },
    toAddress: {
      label: "Destination",
      line1: "88 Willow Crest Ln",
      line2: "",
      city: "Round Rock",
      state: "TX",
      zip: "78664",
      accessNotes: "Garage access available. Single-story. Tight hallway near master.",
    },
    truck: {
      size: "26ft Box Truck",
      plate: "HM-104",
      capacityCuFt: 1600,
      needed: 1280,
    },
    crew: [
      {
        id: "C-101",
        name: "Marcus Reed",
        role: "Lead Mover",
        phone: "(512) 555-0211",
        initials: "MR",
        color: "bg-brand-500",
        status: "confirmed",
        rating: 4.9,
      },
      {
        id: "C-102",
        name: "Diego Alvarez",
        role: "Mover / Driver",
        phone: "(512) 555-0218",
        initials: "DA",
        color: "bg-emerald-500",
        status: "confirmed",
        rating: 4.8,
      },
      {
        id: "C-103",
        name: "Tyler Brooks",
        role: "Mover",
        phone: "(512) 555-0223",
        initials: "TB",
        color: "bg-amber-500",
        status: "confirmed",
        rating: 4.7,
      },
    ],
    items: [
      { id: "i1", name: "Queen mattress + box spring", qty: 1, category: "Bedroom", cuft: 85 },
      { id: "i2", name: "King mattress + box spring", qty: 1, category: "Bedroom", cuft: 110 },
      { id: "i3", name: "Dresser (6-drawer)", qty: 2, category: "Bedroom", cuft: 60 },
      { id: "i4", name: "Nightstands", qty: 4, category: "Bedroom", cuft: 12 },
      { id: "i5", name: "Upright piano", qty: 1, category: "Living", fragile: true, cuft: 95 },
      { id: "i6", name: "Sectional sofa (4-piece)", qty: 1, category: "Living", cuft: 180 },
      { id: "i7", name: "55\" Smart TV", qty: 1, category: "Living", fragile: true, cuft: 18 },
      { id: "i8", name: "Coffee table (glass)", qty: 1, category: "Living", fragile: true, cuft: 14 },
      { id: "i9", name: "Dining table + 6 chairs", qty: 1, category: "Dining", cuft: 75 },
      { id: "i10", name: "China cabinet", qty: 1, category: "Dining", fragile: true, cuft: 55 },
      { id: "i11", name: "Refrigerator (French door)", qty: 1, category: "Kitchen", cuft: 65 },
      { id: "i12", name: "Standard moving boxes", qty: 42, category: "Boxes", cuft: 168 },
      { id: "i13", name: "Wardrobe boxes", qty: 6, category: "Boxes", cuft: 90 },
      { id: "i14", name: "Bicycle (adult)", qty: 2, category: "Garage", cuft: 24 },
      { id: "i15", name: "Power tools chest", qty: 1, category: "Garage", cuft: 18 },
    ],
    checklist: [
      { id: "ch1", label: "Confirm move 24h before", category: "Pre-move", done: true, assignee: "Office" },
      { id: "ch2", label: "Send crew dispatch sheet", category: "Pre-move", done: true, assignee: "Elena" },
      { id: "ch3", label: "Truck fueled & inspected", category: "Pre-move", done: true, assignee: "Diego" },
      { id: "ch4", label: "Moving dollies (4) loaded", category: "Equipment", done: true, assignee: "Marcus" },
      { id: "ch5", label: "Piano dolly loaded", category: "Equipment", done: true, assignee: "Marcus" },
      { id: "ch6", label: "Furniture pads (24)", category: "Equipment", done: true, assignee: "Marcus" },
      { id: "ch7", label: "Stretch wrap & tape", category: "Equipment", done: true, assignee: "Marcus" },
      { id: "ch8", label: "Wardrobe boxes prepared", category: "Equipment", done: true, assignee: "Tyler" },
      { id: "ch9", label: "Floor runners for both homes", category: "Equipment", done: false, assignee: "Tyler" },
      { id: "ch10", label: "TV/mirror specialty boxes", category: "Equipment", done: true, assignee: "Marcus" },
      { id: "ch11", label: "Walkthrough at origin", category: "On-site", done: true, assignee: "Marcus" },
      { id: "ch12", label: "Inventory & condition log", category: "On-site", done: false, assignee: "Marcus" },
      { id: "ch13", label: "Customer signs BOL", category: "Paperwork", done: false, assignee: "Marcus" },
      { id: "ch14", label: "Collect balance on completion", category: "Paperwork", done: false, assignee: "Marcus" },
    ],
    pricing: {
      subtotal: 2240,
      deposit: 480,
      depositPaid: true,
      fuelSurcharge: 65,
      materials: 95,
      tax: 80,
      total: 2480,
      balanceDue: 2000,
    },
    timeline: [
      {
        id: "tl1",
        time: "May 14",
        title: "Booking confirmed",
        detail: "Estimate accepted, deposit of $480 received",
        icon: "ri-calendar-check-line",
        iconColor: "text-emerald-600",
        iconBg: "bg-emerald-100",
      },
      {
        id: "tl2",
        time: "May 28",
        title: "Pre-move call completed",
        detail: "Confirmed inventory & access notes with customer",
        icon: "ri-phone-line",
        iconColor: "text-indigo-600",
        iconBg: "bg-indigo-100",
      },
      {
        id: "tl3",
        time: "May 31",
        title: "Crew dispatched & truck prepped",
        detail: "Truck HM-104 loaded with equipment, crew assigned",
        icon: "ri-truck-line",
        iconColor: "text-brand-600",
        iconBg: "bg-brand-100",
      },
      {
        id: "tl4",
        time: "07:24 AM",
        title: "Crew clocked in",
        detail: "Marcus, Diego and Tyler clocked in at origin",
        icon: "ri-time-line",
        iconColor: "text-amber-600",
        iconBg: "bg-amber-100",
      },
      {
        id: "tl5",
        time: "08:10 AM",
        title: "Loading started",
        detail: "Walkthrough complete, inventory in progress",
        icon: "ri-play-circle-line",
        iconColor: "text-rose-600",
        iconBg: "bg-rose-100",
      },
    ],
  },
};

// Provide a generic fallback so any project id works
export const fallbackProject: ProjectDetail = projectDetails["MV-2041"];